<template>
  <div id="app" ref="App">
    <div class="header">
      <div class="logo">
        <img src="./assets/images/logo_colours.png" alt="" />
      </div>
      <div class="nav">
        <div :class="{ active: $route.name === 'index' }" @click="goRouter('index')">
          首页
        </div>
        <div :class="{ active: $route.name === 'about' }" @click="goRouter('about', 'aboutBrief')">
          公司简介
        </div>
        <div :class="{ active: $route.name === 'advantage' }" @click="goRouter('advantage', 'advantagePosition')">
          公司优势
        </div>
        <div :class="{ active: $route.name === 'ability' }" @click="goRouter('ability', 'abilityNew')">
          人才招聘
        </div>
        <div :class="{ active: $route.name === 'customer' }" @click="goRouter('customer', 'insureOrderQuery')">
          客户服务
        </div>
        <div :class="{ active: $route.name === 'info' }" @click="goRouter('info', 'infoBasic')">
          信息披露
        </div>
        <div :class="{ active: $route.name === 'contact' }" @click="goRouter('contact', 'contactWay')">
          联系我们
        </div>
      </div>
    </div>
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <div class="footer">
      <div class="nav">
        <div class="item">
          <div class="title" @click="goRouter('about', 'aboutBrief')">
            公司简介
          </div>
          <div v-for="item in aboutList" :key="item.name" @click="goTab(item)">
            {{ item.text }}
          </div>
        </div>
        <div class="item">
          <div class="title" @click="goRouter('advantage', 'advantagePosition')">
            公司优势
          </div>
          <div v-for="item in advantageList" :key="item.name" @click="goTab(item)">
            {{ item.text }}
          </div>
        </div>
        <div class="item">
          <div class="title" @click="goRouter('ability', 'abilityNew')">
            人才招聘
          </div>
          <div v-for="item in abilityList" :key="item.name" @click="goTab(item)">
            {{ item.text }}
          </div>
        </div>
        <div class="item">
          <div class="title" @click="goRouter('customer', 'insureOrderQuery')">
            客户服务
          </div>
          <div v-for="item in customerList" :key="item.name" @click="goTab(item)">
            {{ item.text }}
          </div>
        </div>
        <div class="item">
          <div class="title" @click="goRouter('contact', 'contactWay')">
            联系我们
          </div>
          <div class="phone">电话：400-000-2266</div>
          <div class="email">邮箱：Customer-zrbx@yxinsur.com</div>
          <div class="QRcode">
            <!-- <img src="./assets/images/QRcode.jpeg" alt="" /> -->
          </div>
        </div>
      </div>
      <div class="bottom">
        <div>
          copyright©2017 壹心保险代理（浙江）有限公司
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a style="color: #686868" href="https://beian.miit.gov.cn/#/Integrated/index">ICP备案编号：浙ICP备2022006802号-1</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      aboutList: [{
        name: "aboutBrief",
        text: "公司简介",
        fatherPath: "about",
      },
      // {
      //   name: 'aboutCEO',
      //   text: '总裁寄语',
      //   fatherPath: 'about'
      // },
      {
        name: "aboutIdea",
        text: "经营理念",
        fatherPath: "about",
      },
      {
        name: "aboutIntro",
        text: "股东介绍",
        fatherPath: "about",
      },
      {
        name: "aboutRange",
        text: "营业范围",
        fatherPath: "about",
      },
      // {
      //   name: "aboutCooper",
      //   text: "合作企业和平台",
      //   fatherPath: "about",
      // },
      {
        name: "aboutNews",
        text: "新闻动态",
        fatherPath: "about",
      },
      {
        name: "aboutDuty",
        text: "社会责任",
        fatherPath: "about",
      },
      ],
      advantageList: [{
        name: "advantagePosition",
        text: "公司定位",
        fatherPath: "advantage",
      },
      {
        name: "advantageMachine",
        text: "合伙机制",
        fatherPath: "advantage",
      },
      {
        name: "advantageProduct",
        text: "产品赋能",
        fatherPath: "advantage",
      },
      {
        name: "advantageResources",
        text: "客户赋能",
        fatherPath: "advantage",
      },
      {
        name: "advantageTrain",
        text: "培训赋能",
        fatherPath: "advantage",
      },
      {
        name: "advantageMarketing",
        text: "营销赋能",
        fatherPath: "advantage",
      },
      {
        name: "advantageService",
        text: "服务赋能",
        fatherPath: "advantage",
      },
      {
        name: "advantageTech",
        text: "科技赋能",
        fatherPath: "advantage",
      },
      ],
      abilityList: [{
        name: "abilityNew",
        text: "代理人新模式",
        fatherPath: "ability",
      },
      {
        name: "abilityTeam",
        text: "团队介绍",
        fatherPath: "ability",
      },
      {
        name: "abilityModel",
        text: "典范介绍",
        fatherPath: "ability",
      },
      {
        name: "abilitySpark",
        text: "星火计划",
        fatherPath: "ability",
      },
      {
        name: "abilitySwan",
        text: "鸿鹄计划",
        fatherPath: "ability",
      },
        // {
        //   name: "abilityRecruit",
        //   text: "招贤纳士",
        //   fatherPath: "ability",
        // },
      ],
      customerList: [{
        name: "insureOrderQuery",
        text: "保单查询",
        fatherPath: "customer",
      },],
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      if (to && from) {
        this.$refs.App.scrollTop = 0;
      }
    },
  },
  created() {
    // console.log(this.$route)
  },
  mounted() { },
  methods: {
    goRouter(name, firstTab) {
      if (firstTab === this.$route.params.pathId) return;
      this.$router.push({
        path: firstTab ? `/${name}/${firstTab}` : `/${name}`,
      });
      this.$forceUpdate();
    },
    goTab(item) {
      if (item.name === this.$route.params.pathId) return;
      this.$router.push({
        path: `/${item.fatherPath}/${item.name}`,
      });
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="less">
@import "./styles/reset";
@import "./styles/common";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  overflow-y: auto;
}

.fade-enter-active {
  transition: all 0.3s linear;
}

.fade-leave-active {
  transition: all 0.3s linear;
}

.fade-enter,
.fade-leave-to {
  transform: translateX(500px);
  opacity: 0;
}

.header,
.footer {
  -moz-user-select: none;
  /* Firefox私有属性 */
  -webkit-user-select: none;
  /* WebKit内核私有属性 */
  -ms-user-select: none;
  /* IE私有属性(IE10及以后) */
  -khtml-user-select: none;
  /* KHTML内核私有属性 */
  -o-user-select: none;
  /* Opera私有属性 */
  user-select: none;
  /* CSS3属性 */
}

.header {
  width: 100%;
  height: 72px;
  min-width: 1200px;
  background-color: #333333;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .logo {
    img {
      width: 141px;
    }
  }

  .nav {
    width: 620px;
    display: flex;
    justify-content: space-between;

    div {
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
    }

    .active {
      color: #2488CA;
    }
  }
}

.footer {
  width: 100%;
  min-width: 1200px;
  // height: 576px;
  padding: 50px 0 20px;
  background: rgba(0, 0, 0, 0.85);
  color: #ffffff;

  .nav {
    width: 1200px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;

    .item {
      div {
        line-height: 30px;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      .phone,
      .email {
        &:hover {
          text-decoration: none;
        }
      }

      .QRcode {
        margin-top: 30px;

        img {
          width: 112px;
        }
      }
    }
  }

  .bottom {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-top: 1px solid #686868;
    margin-top: 20px;
  }
}
</style>